var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M224.333,187.427c0,5.794-4.74,10.535-10.535,10.535H42.202c-5.792,0-10.535-4.741-10.535-10.535V68.573 c0-5.794,4.743-10.535,10.535-10.535h171.596c5.796,0,10.535,4.741,10.535,10.535V187.427z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103.928,
    y1: 118.003,
    x2: 37.761,
    y2: 192.737
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 152.075,
    y1: 115.486,
    x2: 218.243,
    y2: 192.737
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: " 35.422,61.817 128.286,133.506 220.379,61.231  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.78bcb3122ecb3200361f9a67d9c2fe02.svg";
export { ForwardRef as ReactComponent };